import React from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import Hero from './components/SpaceHero';
import About from './components/About';
import Services from './components/Services';
import Sectors from './components/Sectors';
import Subsidiaries from './components/Subsidiaries';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import SEO from './components/SEO';
import GlobalSpaceBackground from './components/GlobalSpaceBackground';
import './index.css';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <SEO />
          <div className="App bg-black text-white min-h-screen relative">
            {/* Space/Galaxy Starfield Background */}
            <GlobalSpaceBackground />

            {/* Header */}
            <Header />

            {/* Main Content */}
            <main>
              <Routes>
                <Route path="/" element={
                  <>
                    <Hero />
                    <About />
                    <Services />
                    <Sectors />
                    <Subsidiaries />
                    <Contact />
                  </>
                } />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
              </Routes>
            </main>

            {/* Footer */}
            <Footer />
          </div>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App; 